import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {PipesModule} from '../../../shared/pipes/pipes.module';
import {UserDetailsRepository} from './repositories/user-details.repository';
import {UserDetailsService} from './services/user-details.service';
import {UserDetailsRoutingModule} from './user-details-routing.module';
import {UserDetailsComponent} from './user-details.component';
import {BadgeModule} from 'shared/badges/components/badge-component/badge.module';
import {TooltipModule} from 'ng2-bootstrap/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UserDetailsRoutingModule,
    PipesModule,
    BadgeModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    UserDetailsComponent,
  ],
  providers: [
    UserDetailsService,
    UserDetailsRepository,
  ],
})

export class UserDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-details/user-details.module.ts